import { ArrowOutward } from "@mui/icons-material";
import { makeStyles } from "components/providers/makeStyles";
import { trackClick, TrackingCategory } from "utils/tracking";
import { SponsorConfig, SponsoredContent } from "../../../graphql/generated/types";
import { SponsorContent, SponsorsContainer } from "./SponsorContent";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: "flex",
        width: "fit-content",
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius/2,
        border: `1px solid ${theme.palette.border.light}`,
        "&:hover": {
            backgroundColor: theme.palette.state.action,
            color: theme.palette.text.primary,
        }
    },
    arrow: {
        color: theme.palette.text.contrastSecondary,
    },
}));

export type LinkSponsorTagProps = {
    sponsoredContent: SponsorConfig;
    clickTrackingCategory: TrackingCategory;
};

export const LinkSponsorTag: React.FC<LinkSponsorTagProps> = ({
    sponsoredContent,
    clickTrackingCategory,
}) => {
    const { name } = sponsoredContent;
    const track = trackClick(name, clickTrackingCategory);
    
    return (
        <UntrackedLinkSponsorTag sponsoredContent={sponsoredContent} onClick={track} />
    );
};

export const UntrackedLinkSponsorTag: React.FC<{sponsoredContent: SponsorConfig, onClick?: () => void}> = ({ sponsoredContent, onClick }) => {
    const { text, image, url } = sponsoredContent;
    const classes = useStyles();

    return (
        <a className={classes.wrapper} href={url} target="_blank" rel="noreferrer noopener" onClick={onClick}>
            <SponsorContent text={text} image={image}>
                <ArrowOutward fontSize="small" className={classes.arrow} />
            </SponsorContent>
        </a>
    );
};

export type LinkSponsorTagsProps = {
    sponsoredContents?: SponsoredContent[];
    clickTrackingCategory: TrackingCategory;
};

export const LinkSponsorTags: React.FC<LinkSponsorTagsProps> = ({
    sponsoredContents,
    clickTrackingCategory,
}) => (
    <SponsorsContainer direction={{ sx: "column", sm: "row" }}>
        {sponsoredContents?.map((sponsoredContent) => (
            <LinkSponsorTag key={sponsoredContent.id}
                            sponsoredContent={sponsoredContent.sponsor.config}
                            clickTrackingCategory={clickTrackingCategory}
            />
        ))}
    </SponsorsContainer>
);
